import { environment } from '@environments/environment';
import { StatusType } from '@shared/components/status-badge/status-badge.types';
import { TableInterface } from 'app/core/interfaces/table.interface';

export enum CharterPartyPurposeEnum {
  LOADING = 1,
  DISCHARGING,
  BUNKER,
  DESLOP,
  FRESH_WATER,
  SUPPLY,
  CREW_CHANGE,
  REPAIR,
  DOCKING,
  HUSBANDRY,
  OPL_SERVICES,
  OTHERS,
  FREE_PORT
}

export const CharterPartyPurposes = [
  {
    seq: 1,
    id: CharterPartyPurposeEnum.LOADING,
    name: 'loading',
    description: 'Loading',
    icon: 'sk-cargo',
    is_active: 1,
    is_locationcall: 1,
    color: 'text-red-500 border-red-500 bg-red-200'
  },
  {
    seq: 2,
    id: CharterPartyPurposeEnum.DISCHARGING,
    name: 'discharging',
    description: 'Discharging',
    icon: 'sk-cargo',
    is_active: 1,
    is_locationcall: 1,
    color: 'text-blue-500 border-blue-500 bg-blue-200'
  },
  {
    seq: 3,
    id: CharterPartyPurposeEnum.BUNKER,
    name: 'bunker',
    description: 'Bunker',
    icon: 'sk-bunker',
    is_active: 1,
    is_locationcall: 1,
    color: 'text-yellow-500 border-yellow-500 bg-yellow-200'
  },
  {
    seq: 4,
    id: CharterPartyPurposeEnum.DESLOP,
    name: 'deslop',
    description: 'Deslop',
    icon: 'sk-deslop',
    is_active: 1,
    is_locationcall: 1,
    color: 'text-purple-500 border-purple-500 bg-purple-200'
  },
  {
    seq: 5,
    id: CharterPartyPurposeEnum.FRESH_WATER,
    name: 'fresh_water',
    description: 'Fresh Water',
    icon: 'sk-blood-drop',
    is_active: 1,
    is_locationcall: 0,
    color: 'text-purple-500 border-purple-500 bg-purple-200'
  },
  {
    seq: 6,
    id: CharterPartyPurposeEnum.SUPPLY,
    name: 'supply',
    description: 'Supply',
    icon: 'sk-delivery-truck',
    is_active: 1,
    is_locationcall: 0,
    color: 'text-purple-500 border-purple-500 bg-purple-200'
  },
  {
    seq: 7,
    id: CharterPartyPurposeEnum.CREW_CHANGE,
    name: 'crew_change',
    description: 'Crew Change',
    icon: 'sk-crew-exchange',
    is_active: 1,
    is_locationcall: 0,
    color: 'text-purple-500 border-purple-500 bg-purple-200'
  },
  {
    seq: 8,
    id: CharterPartyPurposeEnum.REPAIR,
    name: 'repair',
    description: 'Repair',
    icon: 'sk-tools',
    is_active: 1,
    is_locationcall: 0,
    color: 'text-purple-500 border-purple-500 bg-purple-200'
  },
  {
    seq: 9,
    id: CharterPartyPurposeEnum.DOCKING,
    name: 'docking',
    description: 'Docking',
    icon: 'sk-jetty',
    is_active: 1,
    is_locationcall: 0,
    color: 'text-purple-500 border-purple-500 bg-purple-200'
  },
  {
    seq: 10,
    id: CharterPartyPurposeEnum.HUSBANDRY,
    name: 'husbandry',
    description: 'Husbandry',
    icon: 'sk-bug',
    is_active: 1,
    is_locationcall: 0,
    color: 'text-purple-500 border-purple-500 bg-purple-200'
  },
  {
    seq: 11,
    id: CharterPartyPurposeEnum.OPL_SERVICES,
    name: 'opl_services',
    description: 'OPL Services',
    icon: 'sk-flashlight',
    is_active: 1,
    is_locationcall: 0,
    color: 'text-purple-500 border-purple-500 bg-purple-200'
  },
  {
    seq: 12,
    id: CharterPartyPurposeEnum.OTHERS,
    name: 'others',
    description: 'Others',
    icon: 'sk-more',
    is_active: 1,
    is_locationcall: 1,
    color: 'text-purple-500 border-purple-500 bg-purple-200'
  },
  {
    seq: 13,
    id: CharterPartyPurposeEnum.FREE_PORT,
    name: 'free_port',
    description: 'Free Port',
    icon: 'sk-more',
    is_active: 1,
    is_locationcall: 0,
    color: 'text-green-500 border-green-500 bg-green-200'
  }
];

export const OtherPurposes = [
  CharterPartyPurposeEnum.DESLOP,
  CharterPartyPurposeEnum.FRESH_WATER,
  CharterPartyPurposeEnum.SUPPLY,
  CharterPartyPurposeEnum.CREW_CHANGE,
  CharterPartyPurposeEnum.REPAIR,
  CharterPartyPurposeEnum.DOCKING,
  CharterPartyPurposeEnum.HUSBANDRY,
  CharterPartyPurposeEnum.OPL_SERVICES,
  CharterPartyPurposeEnum.OTHERS,
  CharterPartyPurposeEnum.FREE_PORT
];

export enum BunkerLogTypeEnum {
  ARRIVAL = 1,
  DEPARTURE,
  SUPPLY
}

export enum ReportTypesEnum {
  NOON_REPORT_SEA = 1,
  NOON_REPORT_PORT,
  MORNING_REPORT,
  EVENING_REPORT,
  CARGO_TANK_MONITORING_REPORT,
  ARRIVAL_REPORT,
  IN_PORT_REPORT,
  DEPARTURE_REPORT,
  MONTHLY_ROB_REPORT
}

export enum ReportStatusEnum {
  DRAFT = 1,
  SUBMITTED
}

export enum TimesheetTypeEnum {
  LOAD = 1,
  DISCHARGE,
  BUNKER
}

export const TimesheetTypes: { id: TimesheetTypeEnum; name: string; description: string; type: StatusType }[] = [
  { id: TimesheetTypeEnum.LOAD, name: 'CARGO LOAD', description: 'Cargo Loading', type: 'error' },
  { id: TimesheetTypeEnum.DISCHARGE, name: 'CARGO DISCHARGE', description: 'Cargo Discharge', type: 'info' },
  { id: TimesheetTypeEnum.BUNKER, name: 'BUNKER', description: 'Bunkering', type: 'warning' }
];

export enum TimesheetStatusEnum {
  DRAFT = 1,
  ISSUED
}

export const TimesheetStatuses = [
  {
    id: TimesheetStatusEnum.DRAFT,
    name: 'Draft',
    color: 'text-orange-500 border-orange-500 bg-orange-50 dark:text-orange-50 dark:bg-orange-500',
    dot: 'bg-orange-500'
  },
  { id: TimesheetStatusEnum.ISSUED, name: 'Issued', color: 'text-blue-600 border-blue-600 bg-blue-50 dark:text-blue-50 dark:bg-blue-600', dot: 'bg-blue-600' }
];

export const CurrentPortRadioGroup = [
  { id: 0, name: 'No, this is not the current Port.' },
  { id: 1, name: 'Yes, this is the current Port' }
];

export const ArrivalRadioGroup = [
  { id: 0, name: 'No, above time is ETA' },
  { id: 1, name: 'Yes, Vessel has arrived at the Port' }
];

export const DepatureRadioGroup = [
  { id: 0, name: 'No, above time is ETD' },
  { id: 1, name: 'Yes, Vessel has sailed from the Port' }
];

export enum FormFilterTypesEnum {
  MANDATORY,
  ALL,
  MOVEMENT_DETAILS,
  BASIC,
  AGENT,
  PORT_TIMINGS,
  CARGO,
  PORT_EXPENSES,
  BUNKER
}

export enum ExpenseTypeEnum {
  EPDA = 1,
  FDA,
  SUPPLEMENT
}

export const ExpenseType = [
  { id: ExpenseTypeEnum.EPDA, name: 'EPDA' },
  { id: ExpenseTypeEnum.FDA, name: 'FDA' },
  { id: ExpenseTypeEnum.SUPPLEMENT, name: 'SUPPLEMENT' }
];

export const PortReportTableConfig: TableInterface[] = [
  {
    width: 1,
    key: 'report_type_id',
    header: 'chartering.vessel_reports_translations.type',
    filter: { type: 'text' },
    style: { textFmt: {}, border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' } }
  },
  {
    width: 1,
    key: 'date_report',
    header: 'chartering.vessel_reports_translations.date',
    filter: { type: 'text' },
    style: {
      alignment: {
        horizontal: 'left'
      },
      dateFmt: { format: 'DD MMM YYYY' },
      border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' }
    }
  },
  {
    width: 1,
    key: 'vessel_name',
    header: 'chartering.vessel_reports_translations.vessel',
    filter: { type: 'text' },
    style: { textFmt: {}, border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' } }
  },
  {
    width: 1,
    key: 'voyage_number',
    header: 'chartering.vessel_reports_translations.voyage',
    filter: { type: 'text' },
    style: {
      textFmt: {},
      alignment: {
        horizontal: 'left'
      },
      border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' }
    }
  },
  {
    width: 1,
    key: 'current_port',
    header: 'chartering.vessel_reports_translations.port',
    filter: { type: 'text' },
    style: { textFmt: {}, border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' } }
  },
  {
    width: 1,
    key: 'datetime_arrival',
    header: 'chartering.vessel_reports_translations.arrival',
    filter: { type: 'date' },
    style: {
      alignment: {
        horizontal: 'left'
      },
      dateFmt: { format: 'HH:mm DD MMM YYYY' },
      border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' }
    }
  },
  {
    width: 1,
    key: 'datetime_departure',
    header: 'chartering.vessel_reports_translations.departure',
    filter: { type: 'date' },
    style: {
      alignment: {
        horizontal: 'left'
      },
      dateFmt: { format: 'HH:mm DD MMM YYYY' },
      border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' }
    }
  },
  {
    width: 1,
    key: 'status_id',
    header: 'chartering.vessel_reports_translations.status',
    filter: { type: 'text' },
    style: { textFmt: {}, border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' } }
  }
];

export const MonthROBTableConfig: TableInterface[] = [
  {
    width: 1,
    key: 'vessel_name',
    header: 'chartering.vessel_reports_translations.vessel',
    filter: { type: 'text' },
    style: { textFmt: {}, border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' } }
  },
  {
    width: 1,
    key: 'vessel_type_id',
    header: 'chartering.vessel_reports_translations.vessel_type',
    filter: { type: 'text' },
    style: { textFmt: {}, border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' } }
  },
  {
    width: 1,
    key: 'year',
    header: 'chartering.vessel_reports_translations.year',
    filter: { type: 'text' },
    style: { textFmt: {}, border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' } }
  },
  {
    width: 1,
    key: 'month',
    header: 'chartering.vessel_reports_translations.month',
    filter: { type: 'text' },
    style: { textFmt: {}, border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' } }
  },
  {
    width: 1,
    key: 'date_report',
    header: 'chartering.vessel_reports_translations.report_submitted',
    filter: { type: 'text' },
    style: {
      alignment: {
        horizontal: 'left'
      },
      dateFmt: { format: 'DD MMM YYYY' },
      border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' }
    }
  },
  {
    width: 1,
    key: 'remarks',
    header: 'chartering.vessel_reports_translations.remarks',
    filter: { type: 'text' },
    style: { textFmt: {}, border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' } }
  },
  {
    width: 1,
    key: 'status_id',
    header: 'chartering.vessel_reports_translations.status',
    filter: { type: 'text' },
    style: { textFmt: {}, border: { direction: 'all', style: 'thin', color: 'FFE0E0E0' } }
  }
];

export const VesselReportApi = {
  inventoryItems: `${environment.PROJECT_API}/vessel-report-group/reports/inventory_items`
};
